import script from "./HousesInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./HousesInfo.vue?vue&type=script&setup=true&lang=js"

import "./HousesInfo.vue?vue&type=style&index=0&id=428cc311&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428cc311"]])

export default __exports__